import React from 'react';
import { Typography, type TypographyProps } from '@mui/material';

export interface TextLinkProps {
  /** Link text */
  children: React.ReactNode;
  /** Custom styles */
  sx?: TypographyProps['sx'];
}

/**
 * TextLink - Atomic underlined text link component
 * 
 * Displays text with underline styling, typically used for CTAs.
 * Renders as a block element by default.
 * 
 * @example
 * ```tsx
 * <TextLink>Sign in to view images</TextLink>
 * ```
 */
export function TextLink({
  children,
  sx,
}: TextLinkProps) {
  return (
    <Typography
      component="span"
      sx={{
        display: 'block',
        textDecoration: 'underline',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default TextLink;
